import { AnimatePresence, motion } from 'motion/react'
import { TASK_DETAILS_LAYOUT } from '../constants'
import { useOpenTaskPage } from '../hooks/useOpenTaskPage'
import { TaskDetails } from './TaskDetails'
import type { TaskDetailsDialogProps } from '../type'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog'

export function TaskDetailsDialog({
  task,
  statuses,
  parentTask,
  open,
  onOpenChange,
  onSubTaskClick,
  onParentTaskClick,
  onNavigateUp,
  onNavigateDown,
  canNavigateUp = false,
  canNavigateDown = false,
  position,
}: TaskDetailsDialogProps) {
  const openTaskPage = useOpenTaskPage()

  if (!task) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-screen h-[100dvh] max-h-[100dvh] max-w-none rounded-none border-0 md:w-[min(1100px,90vw)] md:h-[88vh] md:max-h-[88vh] md:max-w-6xl md:rounded-2xl md:border flex flex-col overflow-hidden p-0 !gap-0 data-[state=open]:slide-in-from-bottom-4 data-[state=closed]:slide-out-to-bottom-4 !duration-300"
        showCloseButton={false}
      >
        <DialogTitle className="sr-only">{task.name || 'Task Details'}</DialogTitle>
        <DialogDescription className="sr-only">Task details for {task.name || 'this task'}</DialogDescription>

        <div className="flex h-full min-h-0 w-full relative flex-1">
          <AnimatePresence mode="wait" initial={false}>
            <motion.div
              key={task.id}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.2, ease: 'easeInOut' }}
              className="absolute inset-0"
            >
              <TaskDetails
                task={task}
                statuses={statuses}
                parentTask={parentTask}
                layout={TASK_DETAILS_LAYOUT.SIDEBAR}
                className="flex-1 min-h-0"
                onSubTaskClick={onSubTaskClick}
                onParentTaskClick={onParentTaskClick}
                chrome={{
                  position,
                  onNavigateUp,
                  onNavigateDown,
                  canNavigateUp,
                  canNavigateDown,
                  onExpand: () => {
                    onOpenChange(false)
                    openTaskPage(task.id)
                  },
                  onClose: () => onOpenChange(false),
                }}
              />
            </motion.div>
          </AnimatePresence>
        </div>
      </DialogContent>
    </Dialog>
  )
}
